import { ListeningOverlay } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function ListeningOverlayDemo() {
  return (
    <Section
      id="listening-overlay"
      title="ListeningOverlay"
      description="The active voice-input affordance: an animated waveform, a live transcript (or a Listening... placeholder), and a stop button. The container is an aria-live=polite status region so the transcript is announced as it streams; the waveform bars are decorative and pulse via a component-scoped keyframe that is disabled under prefers-reduced-motion."
    >
      <VariantBlock label="Listening (empty)" caption="no transcript yet — shows the placeholder">
        <div className="w-full max-w-md">
          <ListeningOverlay onStop={() => {}} />
        </div>
      </VariantBlock>

      <VariantBlock label="With transcript" caption="a live transcript replaces the placeholder">
        <div className="w-full max-w-md">
          <ListeningOverlay onStop={() => {}} transcript="What are the prerequisites for this quest?" />
        </div>
      </VariantBlock>

      <VariantBlock label="More bars" caption="bars controls the waveform density">
        <div className="w-full max-w-md">
          <ListeningOverlay onStop={() => {}} transcript="Recording..." bars={7} />
        </div>
      </VariantBlock>
    </Section>
  );
}
